// Filtros para el listado de incidencias

export interface IncidentFilters {
  status?: IncidentStatus[];
  courier_ids?: string;
  client_id?: number;
  shop_ids?: string;
  team_ids?: string;
  mapped?: boolean;
  from?: string; // fecha formato ISO 8601 (ej: "2025-09-25T00:00:00Z")
  to?: string; // fecha formato ISO 8601 (ej: "2025-09-26T23:59:59Z")
  search?: string; // tracking o order.ref (máx. 255 caracteres)
  include_resolved_by_courier?: boolean;
  page?: number; // mínimo: 1, default: 1
  per_page?: number; // mínimo: 1, máximo: 100, default: 25
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  advanced_filters?: {
    filters: { column: string; operator: string; value: any }[];
    logic: 'AND' | 'OR';
  };
}

export type IncidentStatus = 'pending' | 'in_progress' | 'resolved' | 'canceled';

/** Pestaña del toolbar: todos los estados o uno concreto. */
export type IncidentListStatusTab = 'all' | IncidentStatus;

/** Orden de las pestañas por estado en el listado de incidencias. */
export const INCIDENT_LIST_STATUS_TAB_ORDER: IncidentStatus[] = ['pending', 'in_progress', 'resolved', 'canceled'];

/** Orden completo del toolbar (Todos + estados). */
export const INCIDENT_LIST_STATUS_TABS: IncidentListStatusTab[] = ['all', ...INCIDENT_LIST_STATUS_TAB_ORDER];
